<template>
  <div class="all-infos-containter_6">
    <div class="container">
      <div class="col-lg-10 col-lg-offset-1 all-infos-wrap">
        <div class="all-infos-wrap-d">
          <ol class="navbar-wrap row">
            <li class="col-md-2 col-sm-2 col-xs-8">
              <img src="../../src/assets/images/sign-1-05.png" alt="">
            </li>
            <li :class="{activedecoration : activeToSon == sonModule.to}" @click="selected(sonModule)" :key="index" v-for="(sonModule,index) in sonModules" class="col-md-2 col-sm-2 col-xs-6">
              <router-link :to="sonModule.to">{{$t(`contact.${sonModule.name}`)}}</router-link>
            </li>
          </ol>
          <h5 class="title-url-address">
            <span>当前位置:</span>
            <a class="narmal-select">{{$t(`header.home`)}}></a>
            <a class="narmal-select">{{$t(`header.about`)}}></a>
            <a href="javascript:;" v-text="$t(`contact.${jionTab}`)"></a>
          </h5>
          <div class="contents-box">
            <router-view></router-view>
          </div>



        </div>
      </div>



    </div>
  </div>
</template>

<script>
    export default {
        name: '',
        data () {
            return {
              jionTab:'tab1',
              sonModules:[
                {name:'tab1',to:'/Contact/league_cooperation'},
                {name:'tab2',to:'/Contact/recruitment'}
              ],
              activeToSon:'/Contact/league_cooperation'
            }
        },
        methods:{
          selected:function (sonModule) {
            if(typeof sonModule != 'object') return;
            this.activeToSon = sonModule.to;
            this.jionTab = sonModule.name;
          }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.all-infos-containter_6{
  min-height: calc(80vh);
}
</style>



// WEBPACK FOOTER //
// Contact.vue?4b8bbac0